
export const stepItem = [
    {
        id: 1,
        icon: "../../assets/icons/bear_icon.svg",
        title: "1. korak",
        description: "Kupi staklenu bocu Osječkog piva od 0,33l/0,5l ili Osječkog Crnog radlera od 0,5l",
    },
    {
        id: 2,
        icon: "./../assets/icons/cep_icon.svg",
        title: "2. korak",
        description: "Ispod čepa Osječkog piva ili Osječkog Crnog radlera pronađi kod",
    },
    {
        id: 3,
        icon: "./../assets/icons/camera_icon.svg",
        title: "3. korak",
        description: "Putem mobilnog uređaja prijavi se u web aplikaciju i upiši kod",
    },
    {
        id: 4,
        icon: "./../assets/icons/list_icon.svg",
        title: "4. korak",
        description: "Provjeri svoje sakupljene bodove i zamijeni ih za nagrade",
    },
]